import { splitTextInArray } from './array.js'
import {
  formatBold,
  matchIsTextIsBold,
  removeBoldFromText
} from './bold.js'
import {
  formatBoldItalic,
  formatBoldItalicLetterToNormal,
  formatNormalLetterToBoldItalic,
  matchIsTextIsBoldItalic
} from './bold-italic.js'
import {
  formatItalic,
  matchIsTextIsItalic,
  removeItalicFromText
} from './italic.js'
import { matchIsTextEmpty } from './string.js'

export function matchIsLetterIsUppercase(letter) {
  if (matchIsTextIsBoldItalic(letter)) {
    const normalLetter = formatBoldItalicLetterToNormal(letter)
    return normalLetter.toUpperCase() === normalLetter
  }
  if (matchIsTextIsBold(letter)) {
    const normalLetter = removeBoldFromText(letter)
    return normalLetter.toUpperCase() === normalLetter
  }
  if (matchIsTextIsItalic(letter)) {
    const normalLetter = removeItalicFromText(letter)
    return normalLetter.toUpperCase() === normalLetter
  }
  return letter === letter.toUpperCase()
}

export function matchIsTextIsUppercase(text) {
  if (matchIsTextEmpty(text)) {
    return false
  }
  return splitTextInArray(text).every(matchIsLetterIsUppercase)
}

export function formatNormalToUppercase(text) {
  return text.toUpperCase()
}

export function formatUppercaseToNormal(text) {
  return text.toLowerCase()
}

export function removeUppercaseFromText(text) {
  const textSplittedFormatted = splitTextInArray(text).map((letter) => {
    if (!matchIsLetterIsUppercase(letter)) {
      return letter
    }
    if (matchIsTextIsBoldItalic(letter)) {
      const letterFormatted = formatBoldItalicLetterToNormal(letter)
      return formatNormalLetterToBoldItalic(
        formatUppercaseToNormal(letterFormatted)
      )
    }
    if (matchIsTextIsBold(letter)) {
      const letterFormatted = removeBoldFromText(letter)
      return formatBold(formatUppercaseToNormal(letterFormatted))
    }
    if (matchIsTextIsItalic(letter)) {
      const letterFormatted = removeItalicFromText(letter)
      return formatItalic(formatUppercaseToNormal(letterFormatted))
    }
    return formatUppercaseToNormal(letter)
  })
  return textSplittedFormatted.join('')
}

export function formatUppercase(text) {
  const textSplitted = splitTextInArray(text)
  const textSplittedFormatted = textSplitted.map((letter) => {
    if (matchIsTextIsBoldItalic(letter)) {
      return formatBoldItalic(
        formatNormalToUppercase(formatBoldItalicLetterToNormal(letter))
      )
    }
    if (matchIsTextIsBold(letter)) {
      return formatBold(formatNormalToUppercase(removeBoldFromText(letter)))
    }
    if (matchIsTextIsItalic(letter)) {
      return formatItalic(formatNormalToUppercase(removeItalicFromText(letter)))
    }
    return formatNormalToUppercase(letter)
  })
  return textSplittedFormatted.join('')
}
